import { apiUrl } from "~/config";
import Request from "~/modules/@wmeimob/request/src/index";
import interceptors from "./interceptors";

const instance = Request.create({ baseUrl: apiUrl });
interceptors(instance);

export default instance